<template>
  <div class="elx-imgbox">
    <el-dialog title="图片管理器" v-drag-dialog :visible.sync="visible" class="elx-imgbox-dialog" custom-class="framework-dialog" top="5vh"
      @closed="$emit('closed')"
      @opened="loadListImage">
      <el-tabs v-model="options.activeTab" tab-position="left">
        <el-tab-pane label="选择图片" name="pick" class="pick-block">
          <div class="elx-main elx-img-list" v-loading="isLoading">
            <div class="img-item" v-for="(img, itemIndex) in imgRes.items" @click="onClickListImage(img)" :key="itemIndex">
              <div class="thumb-wp"><img :src="img.thumb" alt="img.name"></div>
              <div class="title">{{img.name}}</div>
              <div class="label" v-if="img.label">{{img.label}}</div>
              <span class="selected" v-if="img.selected"><span class="icon el-icon-check"></span></span>
            </div>
          </div>
          <el-pagination layout="total, prev, pager, next" :page-size="15" :total="imgRes.total" @current-change="onPageNumChange"></el-pagination>
          <div class="elx-foot">
            <el-badge :value="images.length" class="item">
              <el-button type="primary" size="medium" :disabled="images.length == 0" @click="onConfirm">确定</el-button>
            </el-badge>
            <el-button type="primary" size="medium" @click="options.activeTab='upload'" plain v-if="options.enableUpload">上传图片</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="上传图片" name="upload" class="upload-block" v-if="options.enableUpload">
          <div class="elx-main">
            <div class="upload-title">请选择本地图片上传：</div>
            <el-upload
              ref="upload"
              class="upload-img-preview"
              list-type="picture-card"
              accept="image/*"
              :action="options.action"
              :multiple="options.multiple"
              :headers="options.headers"
              :with-credentials="options.withCredentials"
              :data="options.withData"
              :auto-upload="false"
              :limit="uploadNumberLimit()"
              :before-upload="beforeUpload"
              :on-change="onUploadChange"
              :on-progress="onUploadProgress"
              :on-success="onUploadSuccess"
              :on-error="onUploadError"
              :on-exceed="onUploadExceedTip">

              <i class="el-icon-plus"></i>

            </el-upload>

            <div class="upload-tip">{{ uploadTips() }}</div>

            <div class="elx-foot">
              <el-button type="primary" size="medium" @click="onUploadConfirm">确定上传</el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'image-manager',
  model: {
    prop: 'images',
    event: 'change'
  },

  data () {
    return {
      images: [], // 已选图片

      options: {
        listApi: '', // 图片列表数据URL
        action: '', // 图片上传URL
        multiple: true, // 是否支持选取多个图片
        withData: {
          admin: true
        }, // 上传时附带的额外参数
        withCredentials: true, // 支持发送 cookie 凭证信息
        headers: {}, // 设置上传的请求头部
        limit: 10, // 最多可选择图片数量
        maxSize: 2, // 最大尺寸（M）
        activeTab: 'pick',
        enableUpload: true, // 是否启用图片上传
        callback: null
      },

      isLoading: true,
      visible: false,
      uploadSuccessCount: 0,

      imgRes: {
        items: [],
        total: 0,
        pageNum: 1
      }
    }
  },

  methods: {
    setOptions (options) {
      Object.assign(this.options, options)

      // 已选取上传tab但上传未启用，则转到图片选取（仅演示时有这种情况，正式使用不会有）
      if(this.options.activeTab === 'upload' && !this.options.enableUpload) {
        this.options.activeTab = 'pick';
      }
    },

    show () {
      this.visible = true
    },

    hide () {
      this.visible = false
    },

    onConfirm () {
      this.hide()
      if (typeof this.options.callback === 'function') {
        this.options.callback(this.images)
      }
    },

    /**
     * 点击图片时选中或取消选中图片
     * @param img object
     */
    onClickListImage (img) {
      var imgIndex = this.selectedImageIndex(img)

      if (imgIndex >= 0) {
        // 取消图片已选状态
        img.selected = false
        this.images.splice(imgIndex, 1)
        return
      }

      if (!this.options.multiple) {
        // 单选时，先取消已选
        this.images = []
        this.clearListSelected()
      }

      // 选择图片
      if (this.options.multiple && this.images.length >= this.options.limit) {
        this.$message.warning('最多只能选择' + this.options.limit + '张图片')
        return
      }

      img.selected = true
      this.images.push(JSON.parse(JSON.stringify(img)))
    },

    clearListSelected (img) {
      for (let i = 0; i < this.imgRes.items.length; i++) {
        if (img) {
          if (img.url === this.imgRes.items[i].url) {
            this.imgRes.items[i].selected = false
            break
          }
        } else if (this.imgRes.items[i].selected) {
          this.imgRes.items[i].selected = false
        }
      }
    },

    /**
     * 加载图片列表数据
     * @param page
     */
    loadListImage (page) {
      if (!page) page = this.pageNum
      if (!this.options.listApi) {
        throw new Error('listApi is required')
      }
      this.isLoading = true
      this.$api(this.options.listApi, { pageNum: page, pageSize: 15, _r: Math.random() }).then(response => {
        const result = response.page
        this.imgRes.total = parseInt(result.total)

        let imageList = []
        let listCount = 0

        for (let i = 0; i < result.list.length; i++) {
          listCount++

          // 每页只显示15条
          if (listCount > 15) {
            break
          }

          let img = result.list[i]

          if (!img.thumb) {
            img.thumb = img.url
          }

          // 图片名
          if (!img.name) {
            img.name = img.url.substr(img.url.lastIndexOf('/') + 1)
          }

          // 图片其他信息
          if (typeof img.label === 'undefined') {
            img.label = ''
          }

          // 图片选中状态
          img.selected = this.selectedImageIndex(img) > -1

          imageList.push(img)
        }

        this.imgRes.items = imageList
        this.isLoading = false
      })
    },

    /**
     * 图片已选则返回下标，未选则返回-1
     */
    selectedImageIndex (img) {
      for (let i = 0; i < this.images.length; i++) {
        var selectedImg = this.images[i]

        if (selectedImg.url === img.url) {
          return i
        }
      }

      return -1
    },

    /**
     * 分页页面变化时刷新数据
     * @param page
     */
    onPageNumChange (page) {
      this.pageNum = page
      this.loadListImage(page)
    },

    /**
     * 提交上传图片
     */
    onUploadConfirm () {
      this.$refs.upload.submit()
    },

    onUploadProgress (event, file, fileList) {
      console.log(event)
    },

    onUploadChange (file, fileList) {
    },

    /**
     * 上传图片前检查合法性
     * @param file
     * @returns {boolean}
     */
    beforeUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isGif = file.type === 'image/gif'
      const isSize = file.size / (1024 * 1024) < this.options.maxSize

      if (!isJPG && !isPNG && !isGif) {
        this.$message.error(this.uploadTypeTip())
        return false
      }

      if (!isSize) {
        this.$message.error(this.uploadSizeTip())
        return false
      }

      return true
    },

    uploadNumberLimit () {
      if (!this.options.multiple) {
        return 1
      }

      return this.options.limit - this.images.length
    },

    uploadTypeTip () {
      return '仅支持 jpg/png/gif 图片'
    },

    uploadSizeTip () {
      return '大小不能超过 ' + this.options.maxSize + 'M'
    },

    uploadTips () {
      let tips = [this.uploadTypeTip(), this.uploadSizeTip()]

      if (!this.options.multiple) {
        return tips.join('，')
      }

      if (this.images.length > 0) {
        tips.push('已有' + this.images.length + '张图片')
      }

      const uploadFileNum = this.$refs.upload ? this.$refs.upload.uploadFiles.length : 0
      if (uploadFileNum > 0) {
        tips.push('即将上传' + uploadFileNum + '张图片')
      }

      tips.push('还可以选择' + (this.options.limit - this.images.length - uploadFileNum) + '张图片上传')

      return tips.join('，')
    },

    /**
     * 上传错误处理
     * @param err
     * @param file
     * @param fileList
     */
    onUploadError (err, file, fileList) {
      this.$message.info('服务器打了个盹^_^')
      // console.log(err)
      throw err
    },

    /**
     * 上传成功处理
     * @param response
     * @param file
     * @param fileList
     * @returns {boolean}
     */
    onUploadSuccess (response, file, fileList) {

      let { fileName: name, fileUrl: url, id } = response.data
     
      if (!this.options.multiple) {
        this.images = []
      }

      this.images.push({
        name,
        url,
        id
      })
      this.uploadSuccessCount++

      if (!this.options.multiple || fileList.length === this.uploadSuccessCount) {
        this.onConfirm()

        this.uploadSuccessCount = 0
        this.$refs.upload.clearFiles()
      }
    },

    /**
     * 选择上传文件超过限制文件个数提示
     */
    onUploadExceedTip () {
      this.$message.warning('当前最多只能选择' + this.uploadNumberLimit() + '张图片上传')
    },

    onRemove (imgIndex, img) {
      this.images.splice(imgIndex, 1)
      this.clearListSelected(img)
    }
  },

  mounted () {
    // this.loadListImage()
  },

  computed: {

  }
}
</script>

<style lang="less">
  @import '../color.less';
  .framework-dialog {
    .el-upload-list__item-thumbnail{
      object-fit: cover;
    }
    .el-dialog__header {
      border-bottom: 1px solid #DCDFE6;
      background: @primary;
      .el-dialog__title, .el-dialog__close {
        color: #fff!important;
      }
      .el-dialog__headerbtn {
        height: 24px;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 50%;
        width: 24px;
        &:hover {
          background: rgba(0, 0, 0, 0.4);
        }
      }
      .el-dialog__close {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  
  .elx-images {
    .el-upload-list__item, .el-upload--picture-card {
      width: 100px;
      height: 100px;
      line-height: 100px;
      border-radius: 5px;
    }
  }

  .elx-imgbox-dialog {
    @bg: #f6f6f6;

    .el-badge {
      vertical-align: bottom;
    }

    .el-dialog {
      width: 720px;

      .el-dialog__header {
        border-bottom:1px solid #e8e8e8;
      }

      .el-dialog__body {
        padding:0;
        background: @bg;
      }
    }

    .el-tabs {
      .el-tabs__header {
        margin-right: 0;
        margin-top: 5px;
        .el-tabs__nav-wrap::after {
          background: @bg;
        }
      }
      .el-tabs__item.is-active {
        background: #fff;
      }
      .el-tabs--left .el-tabs__nav-wrap {
        padding-top: 15px;
      }

      .el-tabs__content {
        height: 560px;
        background: #fff;
      }
    }

    .elx-foot {
      padding: 15px 0 0 10px;
      .el-button {
        margin:0 0 0 10px;
      }
    }

    .pick-block {
      position: relative;

      .elx-img-list-loading {
        position: absolute;
        z-index:9;
        left: 0;
        right: 0;
        width: 100%;
        height: 450px;
        background: #fff;
        text-align: center;

        .el-icon-loading {
          font-size:50px;
          color:@primary;
          line-height:250px;
        }
      }
      .elx-img-list {
        padding:10px;
        height:433px;
        overflow: hidden;
        .img-item {
          @imgSize: 100px;
          float: left;
          margin: 10px;
          width: @imgSize;
          cursor: pointer;
          position: relative;
          font-size:12px;
          border-radius: 3px;
          img {
            width: @imgSize;
            height:@imgSize;
            display: block;
            object-fit: cover;
            border-top-left-radius: 3px;
            border-top-right-radius: 3px;
          }

          .title {
            line-height:24px;
            height:24px;
            display: block;
            overflow: hidden;
            background: @bg;
            padding: 0 5px;
            border-bottom-left-radius: 3px;
            border-bottom-right-radius: 3px;
          }

          .label {
            position: absolute;
            z-index:9;
            left: 0;
            bottom: 24px;
            width:100%;
            height:21px;
            line-height:21px;
            text-align: center;
            color:#fff;

            &:after {
              content: ' ';
              position: absolute;
              left: 0;
              bottom: 0;
              width:100%;
              height:21px;
              background: #000;
              opacity: .3;
              z-index:-1;
            }
          }

          .selected {
            position: absolute;
            right: 0px;
            top: 0px;
            width:100%;
            height:100%;
            border:3px solid @primary;
            border-radius: 3px;
            text-align: right;
            .icon {
              background: @primary;
              text-align: center;
              height:24px;
              width:24px;
              line-height:24px;
              display: inline-block;
              font-size:16px;
              color: #fff;
              border-radius: 0 0 0 3px;
              position: absolute;
              right: 0;
              top: 0;
            }
          }
        }

        &::after{
          content:" ";
          display:table;
          height:0;
          clear:both;
          visibility:hidden;
        }
      }

      .el-pagination {
        position: relative;
        padding: 5px;
        margin: 12px 24px 0 20px;
        text-align: left;
        float: none;

        * {
          background: none;
        }
      }
    }

    .upload-block {
      .upload-img-preview {
        padding:20px;
        /* 上传图片预览改为使用背景图片按比例缩放方式 */
        .el-progress-circle {
          width: 80px!important;
          height: 80px!important;
          margin-left: 23px;
        }
        .el-upload--picture-card, .el-upload-list--picture-card .el-upload-list__item, .el-upload-list--picture-card .el-upload-list__item .wp {
          width: 90px;
          height: 90px;
          line-height: 98px;
          background-size: cover;
          background-position: 50% 50%;
        }

        .el-upload-list--picture-card .el-upload-list__item-status-label i {
          margin-top: 12px;
          vertical-align: top;
        }
      }

      .upload-tip {
        padding: 0 20px;
        font-size: 13px;
        color:#999;
      }

      .upload-title {
        font-size:16px;
        color: #666;
        padding: 20px 0 0 20px;
      }

    }
  }

  .el-upload-list__item-actions {
    a {
      i {
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/framework/image-manager/manager.vue